/**
 * The record a print is "of". Passing it turns on the things that only make
 * sense with a hike behind them: the per-day fan-out, the information sheet
 * and the QR code back to the live route.
 */
export interface PrintMapSourceRef {
  type: string;
  id: string | number;
}

export function buildPrintMapUrl(
  trailIds: Array<string | number>,
  source?: PrintMapSourceRef | null,
): string | null {
  if (!Array.isArray(trailIds) || trailIds.length === 0) {
    return null;
  }

  const normalizedIds = trailIds
    .map((id) => {
      if (id == null) return null;
      const stringified = String(id).trim();
      return stringified.length > 0 ? stringified : null;
    })
    .filter((id): id is string => Boolean(id));

  if (normalizedIds.length === 0) {
    return null;
  }

  const params = new URLSearchParams();
  normalizedIds.forEach((id) => {
    params.append('data_ids[]', id);
    params.append('data_types[]', 'Ptv2::PlannedTrail');
  });

  if (source?.type && source.id != null && String(source.id).length > 0) {
    params.append('source_type', source.type);
    params.append('source_id', String(source.id));
  }

  return `/print-maps?${params.toString()}`;
}

export function openPrintMap(
  trailIds: Array<string | number>,
  target: '_blank' | '_self' = '_blank',
  source?: PrintMapSourceRef | null,
): boolean {
  const url = buildPrintMapUrl(trailIds, source);
  if (!url) {
    return false;
  }

  if (typeof window === 'undefined') {
    return false;
  }

  window.open(url, target, 'noopener');
  return true;
}

export function openPrintMapFallback(url?: string): boolean {
  if (!url || typeof window === 'undefined') {
    return false;
  }

  window.open(url, '_blank', 'noopener');
  return true;
}
